"use client";

import { Outlet } from "react-router-dom";
import CookieConsent from "@/components/CookieConsent";
import { Toaster } from "@/components/ui/sonner";

export default function Layout() {
  return (
    <>
      <Outlet />
      <CookieConsent />
      <Toaster />
    </>
  );
}
